<template>
  <div class="LS01_background">
    <div class="position">
      <div class="card">
        <div class="container_CAD01">
          <div class="block">
            <div class="btn-exit" @click="onClose">
              <ButtonIcon
                :iconUrl="`/icons/close.svg`"
                :bgColor="`#ed8e91`"
                :size="1"
              />
            </div>
            <div
              style="display: flex; flex-direction: column"
              v-for="(item, index) in message"
              :key="index"
            >
              <div
                :style="`display: flex;
                  justify-content: ${
                    item.position == 'left' ? 'flex-start' : 'flex-end'
                  };
                  margin-top: 5%;
                  `"
              >
                <div style="display: flex; align-items: center">
                  <div class="avatar">
                    <Avatar
                      :avatarUrl="baseUrl + item.media[0].url"
                      v-show="item.position == 'left'"
                    />
                  </div>
                  <div
                    class="chat"
                    :style="`background-color:${
                      item.position == 'left' ? '#F2F2F2' : '#1E5BD7'
                    };
                  color: ${item.position == 'left' ? 'black' : 'white'}
                  `"
                  >
                    <div class="font_chat fontChinese">
                      {{ checkLanguage(item.message) }}
                    </div>
                    <div
                      class="sound_img"
                      v-if="item.media[1]?.url != null"
                      @click="onPlay(index)"
                    >
                      <div class="btn_icon">
                        <div class="player" />
                        <img
                          :src="soundbar"
                          style="width: 60%; object-fit: contain"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="avatar" v-show="item.position == 'right'">
                    <Avatar :avatarUrl="baseUrl + item.media[0].url" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  align-item: flex-end;
                  margin-right: 2.5%;
                "
              >
                <div>
                  <div class="button" @click="nextMessage">
                    <div col="12">
                      <div style="font-size: 18px">NEXT</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/elements/Buttons/ButtonIcon';
import Avatar from '@/components/elements/avatar/Avatar';
import '../../../../assets/scss/chinessStyle2.scss';
export default {
  components: {ButtonIcon, Avatar},
  name: 'ChatMessage',
  props: {
    content: Array,
    lang: String,
  },
  data() {
    return {
      soundbar: '/icons/play-circle.svg',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      message: [],
      soundObject: null,
      index_play: null,
      isPlay: false,
    };
  },
  methods: {
    onPlay: function (index) {
      //เช็คว่าเคยกดเล่นเสียงหรือยังถ้ายังจะให้ index ที่ส่งมา เก็บเข้าใน state
      if (this.index_play == null) {
        this.index_play = index;
      }
      //หยุดเล่นเสียงตำแหน่งเดิม
      if (this.index_play == index && this.isPlay) {
        //ถ้าใช่
        this.soundObject.pause();
        this.isPlay = false;
        return;
      }
      //เล่นเสียงตำแหน่งเดิม
      else if (
        this.index_play == index &&
        this.isPlay == false &&
        this.soundObject != null
      ) {
        this.soundObject.play();
        this.isPlay = true;
        return;
      }
      //หยุดเล่นเสียงก่อนหน้าและเล่นเสียงใหม่
      else if (this.soundObject != null && this.index_play != index) {
        this.soundObject.pause();
        this.isPlay = false;
        this.index_play = index;
      }

      this.soundObject = new Audio(
        'https://mdl.mfu.ac.th/' + this.content[index].media[1].url,
      );
      this.isPlay = true;
      this.soundObject.play();
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    nextMessage: function () {
      let index_message = this.message.length;
      if (this.content.length == index_message) {
        this.$emit('nextPage', true);
        return;
      }
      this.message.push(this.content[index_message]);
    },
    onClose() {
      //else just redirect to mainpage
      this.$router.push(`/v4/LS01/1`);
    },
  },

  computed: {},
  watch: {},
  created() {
    this.message.push(this.content[0]);
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.btn_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
  padding-top: 0px;
  padding-bottom: 0px;
  object-fit: cover;
  border-radius: 8px !important;
  cursor: pointer;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-bottom: 10%;
}
.container_CAD01 {
  padding-left: 4%;
  padding-right: 4%;
}
.card {
  background-color: white;
  width: 900px;
  height: auto;
  margin-bottom: 12%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px; /* 5px rounded corners */
}
.font_setting {
  padding: 20px 20px 20px 20px;
  color: #1d5bd7;
}
.chat {
  display: flex;
  height: auto;
  width: 100%;
  align-items: center;
  margin-bottom: 0;
  border-radius: 8px !important;
}
.font_chat {
  font-size: 20px;
  margin-left: 20px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.icon_btn {
  line-height: 20px;
  vertical-align: center;
  background-image: url('/icons/play-arrow.svg')
    no-repeat;
  background-size: contain;
}
.button {
  padding: 8px 50px;
  margin-top: 20%;
  margin-bottom: 20%;
  background-color: #89abe6;
  color: white;
  font-size: 12px;
  border-radius: 8px !important;
  cursor: pointer;
}
* {
  user-select: none;
}
.btn-exit {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 98%;
  z-index: 90;
}
.container_CIT01 {
  margin-left: auto;
  margin-right: auto;
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1%;
}
.ContentProgressBar {
  // padding-left: 40%;
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }

  // .progress-bar {
  //     background-color: #b3b3b3 !important;
  // }
}

.progress-bar-striped {
  background-image: none !important;
}
/* Add rounded corners to the top left and the top right corner of the image */
.radius_img {
  width: 50px;
  position: absolute;
  height: 50px;
}
.text-center {
  height: 0;
  width: 0;
}
.avatar {
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  margin: 0 10px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .btn-exit {
    width: 50px;
    height: 50px;
    left: 92%;
  }
  .card {
    width: 320px;
  }
  .sound_img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 50px;
  }
  .chat {
    display: flex;
    justify-content: space-around;
  }
  .font_chat {
    font-size: 25px;
    width: 70%;
    // background-color: chartreuse;
  }
}
// resolution ipad
@media only screen and (min-width: 600px) and (max-width: 768px) {
  .card {
    width: 85%;
  }
  .btn-exit {
    width: 70px;
    height: 70px;
    left: 95%;
    top: 5%;
  }
  .font_chat {
    font-size: 25px;
  }
  .position {
    padding-bottom: 10%;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }
}
// PC MAX 1800
@media only screen and (min-width: 1366px) and (max-width: 1800px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }
}
// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
